<template>
  <div class="CProductInvent">
    <!-- 搜索框 -->
    <div class="searchBox">
      <el-input class="searchInput" placeholder="产品编号" v-model="keyword.number" clearable></el-input>
      <el-input class="searchInput" placeholder="产品名称" v-model="keyword.productName" clearable></el-input>
      <el-select v-model="keyword.type" placeholder="请选择类别" clearable>
        <el-option label="" value=""></el-option>
      </el-select>
      <el-cascader @change="cargoChange" placeholder="请选择货位信息" :options="keyword.cargoList" :props="keyword.props" :show-all-levels="false" clearable></el-cascader>
      <el-button class="searchBtn" type="primary">搜 索</el-button>
    </div>
    <!-- 添加信息 -->
    <div class="addButton">
      <el-button type="primary">生成报表</el-button>
    </div>

    <el-table v-loading="loading" :data="tableData" style="width: 100%">
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column label="产品编号" prop=""></el-table-column>
      <el-table-column label="产品名称" prop=""></el-table-column>
      <el-table-column label="产品批号" prop=""></el-table-column>
      <el-table-column label="类别" prop=""></el-table-column>
      <el-table-column label="规格" prop=""></el-table-column>
      <el-table-column label="供应商" prop=""></el-table-column>
      <el-table-column label="总库存">
        <template slot-scope="scope">
          <el-button type="text" @click="openDio('detail')">27</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="paging" v-if="total>limits">
      <el-pagination
        @current-change="CurrentChange"
        :current-page.sync="curr"
        :page-size="limits"
        layout="prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <el-dialog :title="dioTitle" :visible.sync="InwareDio" :width="dioWidth" class="configDio wareDio" center>
      <div class="contDio">
        <div class="info">
          <span>产品编号：12314894845645</span>
          <span>产品名称：xxx</span>
          <span>产品批号：xxx</span>
          <span>类别：xxx</span>
          <div>规格：xxxxxxxxxxxxxxxxxxxx</div>
          <div>供应商：xxxxxxxxxx</div>
        </div>
        <el-table :data="dioform.tabData" style="width: 100%" max-height="300">
          <el-table-column label="仓库" prop=""></el-table-column>
          <el-table-column label="库位" prop=""></el-table-column>
          <el-table-column label="货架ID" prop=""></el-table-column>
          <el-table-column label="货架" prop=""></el-table-column>
          <el-table-column label="货位" prop=""></el-table-column>
          <el-table-column label="库存" prop=""></el-table-column>
        </el-table>
        <div class="paging" v-if="dioform.total>dioform.limits">
          <el-pagination
            @current-change="dioCurrChange"
            :current-page.sync="dioform.curr"
            :page-size="dioform.limits"
            layout="prev, pager, next, jumper"
            :total="dioform.total">
          </el-pagination>
        </div>
        <div class="foot">
          <el-button>确定</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"
  export default {
    data(){
      return {
        //搜索
        keyword:{
          number:'',//订单号
          productName:'',//产品名称
          type:'',//类别
          cargo:'',//货位
          cargoList:[{
            id:'1',
            name:'一级',
            children:[{
              id:'2',
              name:'二级'
            }]
          }],
          props:{
            checkStrictly: true,
            label:'name',
            value:'id',
            children:'children'
          },
        },

        loading:false,//表格刷新
        tableData:[{id:'1'}],//表格数据

        //分页
        curr:1,
        limits:10,
        total:10,

        dioTitle:'',//弹窗标题
        dioWidth:'',//弹窗宽度
        dioType:'',//弹窗类型
        InwareDio:false,//弹窗状态
        dioform:{
          tabData:[],
          //分页
          curr:1,
          limits:10,
          total:10,
        },

        rules:{
          number:[
            { required: true, message: '请输入产品编号', trigger: 'blur'},
          ],
        },

      }
    },
    components: {
      CBreadCrumb,
    },
    created(){
      
    },
    methods:{
      //货位选择
      cargoChange(value){
        this.keyword.cargo = value
      },
      //打开弹窗
      openDio(type){
        this.dioType = type
        if(type == 'detail'){
          this.dioWidth="700px"
          this.dioTitle="产品库存"
        }
        this.InwareDio = true
      },

      //弹窗分页
      dioCurrChange(val){
        this.dioform.curr = val
        //执行列表方法
      },
      //分页
      CurrentChange(val){
        this.curr = val
        //执行列表方法
      },
    },
  }
</script>
<style lang="scss">
.CProductInvent{
  padding: 24px;
  .w100{
    width: 100px;
  }
  .w300{
    width: 300px;
  }
  .searchBox {
    margin-bottom: 20px;
    .searchInput {
      width: 200px;
    }
  }
  .contDio{
    .info{
      span{
        margin-right: 30px;
        margin-bottom: 10px;
        display: inline-block;
      }
    }
    .foot{
      text-align: right;
      margin-top: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Page/CStorage/CInventoryRecord/CProductInvent.vue